import { Component, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TableOperatorsComponent } from '../table-operators/table-operators.component';
import { CreateAccountModalComponent } from './create-account/create-account.modal.component';

@Component({
  selector: 'app-operators',
  templateUrl: './operators.component.html',
  styleUrls: ['./operators.component.scss'],
})
export class OperatorsComponent {
  filtroConta = new FormGroup({
    account: new FormControl<string>(''),
  });

  isFilterColapsed = false;
  public isLoaded = false;

  @ViewChild(TableOperatorsComponent) table!: TableOperatorsComponent;

  constructor(private modalService: NgbModal) { }

  filterColapse(): void {
    this.isFilterColapsed = !this.isFilterColapsed;
  }

  onOperatorsLoaded(): void {
    this.isLoaded = true;
  }

  buscar(): void {
    const cnpj = (this.filtroConta.controls.account.value ?? '').trim();

    this.isLoaded = false;
    this.table.search(cnpj);
  }

  newAccount(): void {
    const modalRef = this.modalService.open(CreateAccountModalComponent, {
      size: 'xl',
      centered: true,
      windowClass: 'modal-wide',
      backdrop: 'static',
      keyboard: true,
    });

    modalRef.closed.subscribe((result: any) => {
      if (result?.saved) {
        this.isLoaded = false;
        this.table.load(result?.cnpj ?? '');
      }
    });
  }

  async pasteDocument(): Promise<void> {
    try {
      const text = await navigator.clipboard.readText();
      const digits = (text ?? '').replace(/\D/g, '');
      this.filtroConta.controls.account.setValue(this.applyCpfCnpjMask(digits));
    } catch (err) {
      console.error('Erro ao colar documento:', err);
    }
  }

  private applyCpfCnpjMask(value: string): string {
    const digits = (value ?? '').replace(/\D/g, '');

    if (digits.length <= 11) {
      return digits
        .replace(/^(\d{3})(\d)/, '$1.$2')
        .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1-$2')
        .slice(0, 14);
    }

    return digits
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2')
      .slice(0, 18);
  }
}